import script from "./previewProforma.vue?vue&type=script&setup=true&lang=js"
export * from "./previewProforma.vue?vue&type=script&setup=true&lang=js"

import "./previewProforma.vue?vue&type=style&index=0&id=7ceea7d1&scoped=true&lang=css"

import exportComponent from "/Users/saameen/Documents/www/hs/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-7ceea7d1"]])

export default __exports__